class IntroSwitcher {
  constructor() {
    this.intro = document.querySelector('[data-intro]');
    this.introContent = this.intro.querySelectorAll('[data-intro-content]');
    this.introButtons = document.querySelectorAll('[data-intro-button]');
    this.count = parseInt(this.intro.dataset.intro);
    this.counter = document.querySelector('[data-intro-counter]');
    this.index = 0;
    this.autoPlay = true;
    this.interval = null;
    this.duration = 5000;

    this.init();
  }

  init() {
    if (!this.intro) return;

    new SetCircleValues(this.duration);
    setTimeout(() => {
      this.update();
    }, 500);
    this.startAutoPlay();

    this.introButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        console.log('clicked');
        if(button.dataset.introButton === 'next') {
          if(this.index === this.count - 1) {
            this.index = 0;
          } else {
            this.index++;
          }
          this.update();
        } else {
          if(this.index === 0) {
            this.index = this.count - 1;
          } else {
            this.index--;
          }
          this.update();
        }
      });
    });
  }

  restartAutoPlay() {
    clearInterval(this.interval);
    this.startAutoPlay();
  }

  startAutoPlay() {
    this.interval = setInterval(() => {
      if(this.autoPlay) {
        if(this.index === this.count - 1) {
          this.index = 0;
        } else {
          this.index++;
        }
        this.update();
      }
    }, this.duration);
  }

  update() {
    this.introContent.forEach((content, index) => {
      let marker = content.querySelector('[data-marker]');
      let pos = parseInt(content.dataset.introContent) ;
      if(this.index === pos) {
        content.dataset.visible = 'true';
        content.dataset.pos = 'current';
        if(marker) marker.dataset.marker = 'active';
      } else if(this.index > pos) {
        content.dataset.visible = 'false';
        if(this.index === this.count - 1 && pos === 0) {
          content.dataset.pos = 'next';
        } else {
          content.dataset.pos = 'prev';
        }
        if(marker) marker.dataset.marker = 'inactive';
      } else {
        content.dataset.visible = 'false';
        if(this.index === 0 && pos === this.count - 1) {
          content.dataset.pos = 'prev';
        }
        else {
          content.dataset.pos = 'next';
        }
        if(marker) marker.dataset.marker = 'inactive';
      }
    });
    this.updateCounter();
    this.restartAutoPlay();
  }

  updateCounter() {
    this.counter.textContent = `${this.index + 1}`;
  }
}

class SetCircleValues {
  constructor(duration) {
    this.circles = document.querySelectorAll('.progress-ring');
    this.duration = duration || 1000;
    this.init();
  }

  init() {
    if (!this.circles) return;
    this.setValues();

    window.addEventListener('resize', () => {
      this.setValues();
    });
    
  }

  setValues() {
    this.circles.forEach((circle, index) => {
      circle.style.setProperty('--duration', `${this.duration}ms`);
      let inner = circle.querySelector('.progress-ring__circle');
      const value = getComputedStyle(inner).getPropertyValue('r').replace('px', '');
      circle.style.setProperty('--r', value);
      circle.style.setProperty('--circumference', 2 * Math.PI * value);
    });
  }
}

new IntroSwitcher();